import { authApi } from 'api/modules';
import { useSubscribable } from 'utils/react';

export function useAuthorized() {
  const user = useSubscribable(() => authApi.getUser$(), [], { clientOnly: true }).toNullable();

  return !!user;
}
